import React from 'react';
import ChatInterface from './ChatInterface';

const ChatPage: React.FC = () => {
  return (
    <div className="h-screen flex flex-col bg-white dark:bg-dark-primary text-text-primary dark:text-dark-text">
      <main className="flex-1 overflow-hidden">
        <ChatInterface />
      </main>
    </div>
  );
};

export default ChatPage;
